@if (project().id && (!projectMatches || projectMatches.length === 0)) {
  <div>
    <strong>Unfortunately, there aren't any new resource matches for your project - check back soon!</strong>
  </div>
}
@if (projectMatches && projectMatches.length > 0) {
  <div>
    <p-dataView #dv [value]="projectMatches" [paginator]="projectMatches.length > 9" [rows]="9" filterBy="project.title" [sortField]="sortField" [sortOrder]="sortOrder">
      <ng-template pTemplate="header">
        <div class="flex flex-col md:flex-row md:justify-between gap-2">
        </div>
      </ng-template>
      <ng-template let-projectMatches #list>
        @for (projectMatch of projectMatches; track projectMatch) {
          <div class="col-span-12">
            @if (projectMatch.project) {
              <div class="flex flex-col md:flex-row items-center p-3 w-full">
                <img height="64px" [src]="'assets/book_image_placeholder.png'" [alt]="projectMatch.project.name" class="my-4 md:my-0 shadow-2 mr-5"/>
                <div class="flex-1 flex-column items-center text-center md:text-left">
                  <div class="font-bold text-2xl">{{projectMatch.projectMatchStatus.valueOf()}}</div>
                  <div class="mb-2">{{projectMatch.betaReader.platformUser.screenName}}</div>
                  <!-- p-rating [readonly]="true" [cancel]="false" styleClass="mb-2"></p-rating -->
                  <div class="flex items-center mt-2">
                    @for (tag of matchMeta.get(projectMatch.project.uuid).tags; track tag) {
                      <span>
                        <i [class]="'pi mr-2 '+tag.icon"></i>
                        <span class="font-semibold">{{tag.label}}</span>
                      </span>
                    }
                  </div>
                </div>
                <div class="flex flex-col md:flex-column justify-between w-full md:w-auto items-center md:align-items-end mt-5 md:mt-0">
                  <!--span class="text-2xl font-semibold mb-2 align-self-center md:align-self-end">{{projectMatch.betaReader.platformUser.bioText}}</span-->
                  @if (!matchMeta.get(projectMatch.project.uuid).showDetail) {
                    <p-button [raised]="true" icon="pi pi-info-circle" label="See More" (click)="matchMeta.get(projectMatch.project.uuid).showDetail=true" styleClass="mb-2 p-button-sm" />
                  }
                  @if (matchMeta.get(projectMatch.project.uuid).showDetail) {
                    <p-button icon="pi pi-info-circle" label="Close Detail" (click)="matchMeta.get(projectMatch.project.uuid).showDetail=false" styleClass="mb-2 p-button-sm" />
                  }
                  <span [class]="'project-badge status-' + projectMatch.project.beta_reader_status?.toLowerCase()">{{projectMatch.project.beta_reader_status==BetaReaderStatus.PENDING_RESPONSE?'Interested':projectMatch.project.beta_reader_status}}</span>
                </div>
              </div>
            }
            <hr/>
            @if (matchMeta.get(projectMatch.project.uuid).showDetail) {
              <resource-detail [resourceMatch]="projectMatch" />
            }
          </div>
        }
      </ng-template>
    </p-dataView>
  </div>
}
